import React from 'react';
import { FieldRenderer } from '../fieldRegistry';
import { TitleField } from './TitleField';

export const renderTitleField: FieldRenderer = (
  field,
  formState,
  updateFormState
) => {
  const isRequired = field.validation?.type === 'required';
  return (
    <TitleField
      key={field.name}
      value={(formState[field.name] as string) || ''}
      onChange={(value: string) =>
        updateFormState(prev => ({ ...prev, [field.name]: value }))
      }
      maxLength={field.maxLength}
      placeholder={field.placeholder}
      required={isRequired}
    />
  );
};
